export interface GstAddress {
  line1: string;
  line2: string;
  city: string;
  state: string;
  pincode: string;
  country: string;
}

export interface GstPercentage {
  cgst: string;
  sgst: string;
  igst?: string | null;
}

export enum GstOptions {
  EXCLUSIVE = 'exclusive',
  INCLUSIVE = 'inclusive'
}

export interface GstInput {
  showGstDetails: boolean;
  gstIn: string;
  hsnCode: string;
  address: GstAddress;
  gstValue: GstPercentage;
  selectedGstType: GstOptions;
}

export interface TemplateData {
  id: string;
  name: string;
  templateId: string;
}

export interface SampleTemplate {
  id: string;
  name: string;
  content: string;
  sampleValues: {
    key: string;
    value: string;
  }[];
  buttons: {
    actionType: string;
    urlType: string;
    baseUrl: string;
    buttonText: string;
  };
}

export interface ProviderConfig {
  id?: string;
  provider_code?: string;
  name?: string;
  configuration?: {
    [key: string]: string;
  }[];
  is_primary?: boolean;
  notification_provider_config_id?: string;
}
